import { httpClient } from '../http/httpClient';
import { UserRoleResponse } from '../../entities/UserRole';

export interface UserRoleParams {
  role: string;
  limit?: number;
  skip?: number;
  sort?: string;
  managerIds?: string
}

export const getUsersByRole = async (params: UserRoleParams) => {
  const { data } = await httpClient.get<UserRoleResponse>(`/user/role/${params.role}`, {
    params: {
      limit: params.limit,
      skip: params.skip,
      sort: params.sort,
      managerIds: params.managerIds,
    },
  });

  return data;
};
